import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import * as z from "zod";
import { ScanVerifyPopupSchema } from "./get-scan-verify-popups";

export const getPackingSlipPredictions = {
  name: "getPackingSlipPredictions" as const,
  input: z.object({ currentGroupId: z.string() }),
  output: z.object({
    predictions: z.array(FulfillmentGroupDataSchema),
    binsResolvedFulfillmentGroupIds: z.array(z.string()).nullish(),
    scanVerifyPopups: z
      .array(
        z.object({
          fulfillmentGroupId: z.string(),
          popups: z.array(ScanVerifyPopupSchema),
        }),
      )
      .nullish(),
  }),
};
